import { useForm, SubmitHandler } from "react-hook-form"
import styles from "./SupplierRegister.module.css"
import { SupplierData } from "./SupplierTable"
import { Button } from "@mui/material"
import { Link, useNavigate, useLocation } from "react-router-dom"
import { useEffect, useContext } from "react"
import { AuthContext, AuthContextType } from "../../Auth"
import { baseUrl } from "../../url"


export default function SupplierEditor() {

    const { setAuth } = useContext(AuthContext) as AuthContextType;
    const navigate = useNavigate();
    const location = useLocation();
    const editData: SupplierData = location.state;
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<SupplierData>(
        {
            mode: 'onBlur',
            defaultValues: editData
        }
    )

     useEffect(() => {
            const checkAuth = async () => {
                try {
                    const response = await fetch(`${baseUrl}/checkAuth`, {
                        method: "POST",
                        credentials: "include",
                        headers: { 'Content-Type': 'application/json' },
                    });
                    const data = await response.json();
                    if (!data.result) {
                        console.log("Not authenticated");
                        setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
                        return navigate("/login");
                    }
                     const response2 = await fetch(`${baseUrl}/getusersdata`,{
                        method: "POST",
                        credentials: "include",
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ username: data.username })
                    })
                    const data2 = await response2.json();
                    console.log("Authenticated user:", data.username, "Office:", data2.office,"Authority:",data2.authority);
                    setAuth({ username: data.username, isAuthenticated: true, office: data2.office,authority:data2.authority });
                } catch (error) {
                    console.error(error);
                }
            }
            checkAuth();
        }, [navigate, setAuth]);

    const onSubmit: SubmitHandler<SupplierData> = async (data) => {
        const id_plus = { ...data, supplier_id: editData.supplier_id };
        const datastr = JSON.stringify(id_plus);
        const response = await fetch(`${baseUrl}/updatesupplier`, {
            method: "POST",
            credentials: "include",
            headers: { 'Content-Type': 'application/json' },
            body: datastr
        })
        const resjson = await response.json();
        if(resjson.isAuth===false){
            alert("セッションが切れました。再度ログインしてください");
            setAuth({ username: null, isAuthenticated: false, office: undefined , authority:"user" });
            return navigate("/login");}
        alert(resjson.message);
        if (resjson.submit) {
            navigate("/SupplierTable");
        }
    }

    return (

        <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
            <h2>発注先の登録</h2>
            <p>発注先（メーカー、販売店）の名称を入力してください。（必須）<br />
                （全角で入力してください。）</p>
            <input type="text"
                {...register("supplier",
                    {
                        required: "発注先の名称は必須です。",
                        maxLength: {
                            value: 50, message: "50文字以内で入力してください。"
                        },
                        pattern: { value: /^[\u4E00-\u9FFFぁ-んァ-ヶ０-９ー・]+$/, message: "全角で入力してください。" },
                    })} className={styles.input} />
            <span>{errors.supplier?.message}</span>
            <p>発注用のメールアドレスを入力してください。</p>
            <input type="email" {...register("email", {
                pattern: {
                    value: /\S+@\S+\.\S+/,
                    message: "正しいメールの型式で入力してください。"
                }
            })} className={styles.input} />
            <span>{errors.email?.message}</span>
            <p>送料無料になる注文金額を入力してください。<br />
                （半角数字で入力してください。）</p>
            <input type="number" {...register("freeshipping")} className={styles.input} />
            <span>{errors.freeshipping?.message}</span>
            <p>メールアドレスを登録すると、アプリから発注メールを送ることができます。<br />
                送料無料の金額を入力すると自動発注の条件として設定することができます。</p>
            <Button type="submit" variant="contained" style={{ margin: 15 }} >登録</Button>
            <Link to="/SupplierTable"><Button>キャンセル</Button></Link>
        </form>
    )
}